
import Vue from 'vue'

const state = {
    viewTitle: '',
    backAction: null,
    showLoading: false,
    loadingProgress: 0,
    showLoadingLight: {},
    modalParams: {
        title: '',
        component: null,
        props: {},
        height: 'auto',
        width: 'auto'
    },
    showModal: false,
    showNav: false,
    loginError: ''

}

const getters = {
    viewTitle: state => {
        return state.viewTitle;
    },
    backAction: state => {
        return state.backAction
    },
    showLoading: state => {
        return state.showLoading
    },
    loadingProgress: state => {
        return state.loadingProgress
    },
    showLoadingLight: state => {
        return state.showLoadingLight
    },
    showLoadingLightForScrollLock: state => {
        return state.showLoadingLight && state.showLoadingLight.list && state.showLoadingLight.list == true
    },
    showModal: state => {
        return state.showModal
    },
    modalParams: state => {
        return state.modalParams
    },
    showNav: state => {
        return state.showNav
    },
    loginError: state => {
        return state.loginError
    },
}

const mutations = {
    viewTitle(state,payload){
        state.viewTitle = payload
    },
    backAction(state,payload){
        state.backAction = payload
    },
    showLoading(state,payload){
        if(payload === false){
            setTimeout(()=>{
                state.showLoading = payload
            },500)
            setTimeout(()=>{
                state.loadingProgress = 0
            },1000)
        }
        else{
            state.showLoading = payload
        }

    },
    loadingProgress(state,payload){
        state.loadingProgress = payload
    },

    showLoadingLight(state,payload){
        Vue.set(state.showLoadingLight,payload.id,payload.show)
    },
    showModal(state){
        state.showModal = true
    },
    closeModal(state){
        state.showModal = false
    },
    setModalParams(state,payload){
        Vue.set(state,'modalParams',payload)
    },
    showNav(state,payload){
        state.showNav = payload
    },
    loginError(state,payload){
        state.loginError = payload
    },
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations
};

export default module;



// WEBPACK FOOTER //
// ./src/stores/modules/ui/store.js